__turbopack_context__.v({
  "className": "IjotbG_className",
});
